module.exports = __webpack_public_path__ + "static/z_tall_eveningangels-731753ddc9a3e1d67d9c465a9938f157.jpg";